<template>
    <div class="receipts">
        <div class="ui basic buttons" v-if="show_buttons && buttons_type == 'button'">
            <div class="ui button" :class="{loading: is_printing}" @click="() => !is_printing ? print() : false">
                <!-- 列印簽收單(A5 in A5) -->
                {{ $t('ui.toolbox.receipts.print_receipt') }}(A5 in A5)
            </div>
            <div class="ui button" :class="{loading: is_printing}" @click="() => !is_printing ? print('A4') : false">
                <!-- 列印簽收單(A5 in A4) -->
                {{ $t('ui.toolbox.receipts.print_receipt') }}(A5 in A4)
            </div>
            <div
                v-if="node.identity == '6896bd65c1-28036-39768292'"
                class="ui button" :class="{loading: is_printing}" @click="() => !is_printing ? print('A4', '1x3') : false">
                {{ $t('ui.toolbox.receipts.print_receipt') }}(A4 1x3)
            </div>
        </div>
        <div class="" v-if="show_buttons && buttons_type == 'select'">
            <div class="ui basic buttons">
                <div class="ui floating dropdown icon button" v-dropdown>
                    <span style="margin-right: 3px;">
                        {{ current_paper_size_and_template.name }}
                    </span>
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <div class="item"
                            v-for="item in paper_size_and_templates"
                            @click="current_paper_size_and_template = item"
                            :class="{
                                active: current_paper_size_and_template.name == item.name
                            }">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="ui button"
                    :class="{loading: is_printing}"
                    @click="() => !is_printing ? print(current_paper_size_and_template.paper_size, current_paper_size_and_template.template) : false">
                    {{ $t('ui.toolbox.receipts.print_receipt') }}
                </div>
            </div>
        </div>
        <Item
            v-for="(core_waybill, index) in core_waybills"
            v-if="paper_type == 'ISO_216'"
            :index="index"
            :logo_url="logo_url"
            :title="title"
            :sub_title="sub_title"
            :force_location="force_location"
            :customer_service_hotline="customer_service_hotline"
            :core_waybill="core_waybill"
            :logistician="logistician"
            :key="core_waybill.identity"
            :show_content="show_contents"
            :blank_value_text="blank_value_text">
        </Item>
        <!--
        1. logo_url
        2. title
        3. customer_service_hotline
        4. core_waybill
        5. logistician
        6. location
         -->
    </div>
</template>

<script>
import Item from './item.vue'
export default {
    props: {
        show_buttons: {
            type: Boolean,
            default: false,
        },
        buttons_type: {
            type: String,
            default: 'button',
        },
        show_contents: {
            type: Boolean,
            default: false,
        },
        assigned_core_waybills: {
            type: Array,
            default() {
                return []
            }
        },
        logo_url: {
            type: String,
            default: '/images/tw568_logo.png'
        },
        force_location: String,
        title: String,
        sub_title: String,
        customer_service_hotline: String,
        logistician: Object,
        blank_value_text: {
            type: String,
            default: "",
        },
        channel_name: {
            type: String,
            default: 'receipts',
        },
        operator_identity: {
            type: String,
            default: "",
        },
        is_beta: {
            type: Boolean,
            default: false,
        },
        conditions_search_params: {
            type: Object,
            default() {
                return {}
            }
        },
        default_search_params: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    model: {
        prop: 'value', // return Array
        event: 'update'
    },
    data () {
        return {
            is_printing: false,
            paper_type: "ISO_216",
            paper_size_and_templates: [{
                name: "A4 1x3",
                paper_size: "A4",
                template: "1x3"
            },{
                name: "A5 in A4",
                paper_size: "A4",
                template: null,
            },{
                name: "A5 in A5",
                paper_size: "A5",
                template: null,
            }],
            current_paper_size_and_template: {
                name: "A4 1x3",
                paper_size: "A4",
                template: "1x3"
            },
            core_waybill_identities: [],
            core_waybills: []
        }
    },
    mounted() {
        // print channel
        this.$bus.$off(this.channel_name)
        this.$bus.$on(this.channel_name, (paper_size="A5", template=null, type="ISO_216") => {
            this.paper_type = (type != null) ? type : "ISO_216"
            this.print(paper_size, template, type)
        })
    },
    computed: {
        node: (instance) => instance.$store.state.provider.node,
    },
    methods: {
        async print(paper_size="A5", template=null, type=null) {
            if (!this.is_printing) {
                await new Promise(resolve => {
                    this.$emit('update', false)
                    this.is_printing = true
                    this.core_waybills = []
                    this.core_waybills = this.assigned_core_waybills
                    resolve()
                })
                if (this.core_waybills.length == 0) {
                    if (this.is_beta) {
                        this.$emit('update', true)
                        await this.fetch_core_waybill_identities()
                        await this.fetch_core_waybills()
                    } else {
                        await this.old_fetch_core_waybills()
                    }
                }
                // 初始化列印空間
                await new Promise(resolve => {
                    $("div#print").html("")
                    resolve()
                })

                console.log(this.paper_type);
                console.log(this.core_waybills.length);

                if (this.paper_type == "label") {
                    this.print_labels(paper_size, template)

                } else {
                    // 指定紙張尺寸
                    for (let item of this.$children) {
                        await new Promise(resolve => {
                            item.paper_size = paper_size
                            item.template = template
                            resolve()
                        })
                    }
                    // 抓取分撥
                    for (let item of this.$children) {
                        await item.fetch_distribution()
                    }
                    await this.$nextTick(() => {
                    })
                    // 等待列印內容轉錄至列印空間
                    for (let item of this.$children) {
                        await new Promise(resolve => {
                            $(item.$refs.printable).clone().appendTo('div#print')
                            resolve()
                        })
                    }
                    // 呼叫列印視窗
                    await new Promise(resolve => {
                        window.print()
                        resolve()
                    })
                }

                await new Promise(resolve => {
                    this.is_printing = false
                    this.$emit('update', false)
                    resolve()
                })
            }
        },
        async print_labels(paper_size="100x100", template="1x1") {
            let template_x = 1
            let template_y = 1
            let template_result = template.match(/(\d+)x(\d+)/)
            if (template_result[1] && template_result[2]) {
                template_x = template_result[1]
                template_y = template_result[2]
            }

            let parameters = '.svg?paper_size='+paper_size+
                '&template='+template+
                '&authorization='+localStorage.getItem("authentication_token")

            let base_url = this.$store.state.provider.routes.api_v1_provider_papers_print + parameters
            let numbers = []
            let contents = []
            let src_array = []

            let one_page_count = template_x*template_y

            await new Promise(resolve => {
                _.forEach(this.core_waybills, (core_waybill, index) => {
                    var content = {
                        core_waybill_number: core_waybill.number,
                        printing_type: core_waybill.label_type,
                        staff_identity: this.$store.state.provider.current_staff.identity,
                        data: {
                            count: core_waybill.count,
                            serial: core_waybill.serial
                        }
                    }
                    contents.push(content)
                    numbers.push(core_waybill.number)
                    if (
                        ((index+1)%one_page_count == 0) ||
                        (this.core_waybills.length == index+1)
                    ) {
                        src_array.push({
                            name: numbers.toString(),
                            src: base_url + "&contents=" + JSON.stringify(contents)
                        })
                        contents = []
                        numbers = []
                    }
                })
                resolve()
            })

            await new Promise(resolve => {
                this.$bus.$emit('add_image_print_job',{
                    images: src_array,
                    paper_type: paper_size,
                    numbers_of_one_page: 1
                })
                resolve()
            })
        },
        fetch_core_waybill_identities() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_conditions_core_waybill_identities).parse()

            return axios.post(
                url,
                this.conditions_search_params,
                {
                    headers: {
                        Authorization: localStorage.getItem("authentication_token")
                    }
                }
            ).then(response => {
                if (response.data.status == "success") {
                    this.core_waybill_identities = response.data.core_waybill_identities
                } else if (response.data.status == "failure") {
                    this.$emit('update', false)
                    this.is_printing = false
                    // this.$noty.error("抓取運單失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' + response.data.errors
                        })
                    )

                }
                return response
            }).catch(error => {
                this.$emit('update', false)
                this.is_printing = false
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.core_waybills'),
                        reason: ': ' +this.$t('ui.general.network_abnormality')
                    })
                )

                return Promise.reject(error)
            })
        },
        fetch_core_waybills() {
            if (this.core_waybill_identities) {
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_filter).parse(
                    {},
                    ""
                )
                return axios.post(
                    url,
                    {
                        identity: this.core_waybill_identities,
                        material: {
                            class_names: 'Waybill'
                        },
                        pagination: false
                    },
                    {
                        headers: {
                            Authorization: localStorage.getItem("authentication_token")
                        }
                    }
                ).then(response => {
                    if (response.data.status == "success") {
                        this.core_waybills = response.data.core_waybills
                    } else if (response.data.status == "failure") {
                        // this.$noty.error("抓取運單失敗")
                        this.$emit('update', false)
                        this.is_printing = false
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.core_waybills'),
                                reason: ': ' + response.data.errors
                            })
                        )
                    }
                    return response
                }).catch(error => {
                    this.$emit('update', false)
                    this.is_printing = false
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' +this.$t('ui.general.network_abnormality')
                        })
                    )

                    return Promise.reject(error)
                })
            } else {
                return Promise.resolve()
            }
        },
        old_fetch_core_waybills() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_filter).parse(
                {},
                "?" + object_to_query(this.default_search_params)
            )
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
            .then(response => {
                if (response.data.status == "success") {
                    if (response.data.core_waybills) {
                        this.core_waybills = this.core_waybills.concat(response.data.core_waybills)
                    }
                } else if (response.data.status == "failure") {
                    this.$emit('update', false)
                    this.is_printing = false
                    // this.$noty.error("抓取運單失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' + response.data.errors
                        })
                    )
                }
                return response
            }).catch(error => {
                this.$emit('update', false)
                this.is_printing = false
                this.errors.push(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.core_waybills'),
                        reason: ': ' +this.$t('ui.general.network_abnormality')+','+ error.response.status
                    })
                )
                return Promise.reject(error)
            })
        },
    },
    components: {
        Item
    }
}
</script>

<style scoped>
</style>
